module.exports = __webpack_public_path__ + "img/bison.c6cffda8.png";